<template>
	<div class="WLGHZX">
		<div class="p30" style="line-height: 2;padding-bottom: 1px;">
			<div class="f18 mb" style="text-indent: 36px;">
				大众物流在2008年就开始组建自己的物流规划团队，随着公司业务的不断拓展，先后为一汽集团蔚山工厂、一汽解放动力总成工厂、一汽解放青岛工厂、一汽解放无锡柴油机厂、中国中车、天际汽车等客户输出了各种类型的物流规划方案，积累了丰富的产前、产中物流规划方案设计经验，同时大众物流的规划团队也在不断的进行学习和知识技能更新，目前除了能够为客户提供整体物流服务方案设计，还可以为客户提供物流服务智能化升级方案的设计，为客户智慧化生产提供助力。
			</div>
			<div class="mb">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-image style="width: 100%; height: auto" :src="require('@/assets/WLGHZX_1.jpg')" :fit="'cover'"></el-image>
					</el-col>
					<el-col :span="8">
						<el-image style="width: 100%; height: auto" :src="require('@/assets/WLGHZX_2.jpg')" :fit="'cover'"></el-image>
					</el-col>
					<el-col :span="8">
						<el-image style="width: 100%; height: auto" :src="require('@/assets/WLGHZX_3.jpg')" :fit="'cover'"></el-image>
					</el-col>
				</el-row>
			</div>
			<div class="mb">
				<img src="../../assets/WLGHZX_4.jpg" @click="look(require('../../assets/WLGHZX_4.jpg'))" />
			</div>
			<div class="mb">
				<img src="../../assets/WLGHZX_5.jpg" @click="look(require('../../assets/WLGHZX_5.jpg'))" />
			</div>
			<div class="mb">
				<img src="../../assets/WLGHZX_6.jpg" @click="look(require('../../assets/WLGHZX_6.jpg'))" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			look(url) {
				if (this.$store.state.mobile) {
					window.open(url)
				}
			}
		}
	}
</script>

<style lang="scss">
	.WLGHZX {
		.mb {
			margin-bottom: 55px;
			@media screen and (max-width: 768px) {
				padding: 24px 24px 0;
				margin-bottom: 0px;
				&:last-of-type {
					margin-bottom: 0;
				}
			}
			img {
				max-width: 100%;
				margin: 0 auto;
			}
		}
		@media screen and (max-width: 768px) {
			.f18 {
				font-size: 4.6vw;
				text-align: justify;
			}
		}
	}
</style>
